<div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
  <div class="grid grid-cols-2 md:grid-cols-4 gap-6 lg:gap-8">
    <!-- Active Projects -->
    <div
      class="surface-card relative overflow-hidden group p-8 text-center flex flex-col items-center justify-center"
    >
      <div class="absolute inset-0 bg-gradient-to-b from-primary-soft/20 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100"></div>
      <i class="fa-solid fa-building text-3xl icon-gradient mb-4 relative z-10"></i>
      <div class="text-3xl font-extrabold text-text-primary mb-1 relative z-10 group-hover:icon-gradient transition-all duration-300">
        {{ 'projects.stats.activeProjects.count' | translate }}
      </div>
      <div class="label uppercase tracking-widest text-text-muted mt-2 relative z-10">
        {{ 'projects.stats.activeProjects.label' | translate }}
      </div>
    </div>

    <!-- Developers -->
    <div
      class="surface-card relative overflow-hidden group p-8 text-center flex flex-col items-center justify-center"
    >
      <div class="absolute inset-0 bg-gradient-to-b from-primary-soft/20 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100"></div>
      <i class="fa-solid fa-user-tie text-3xl icon-gradient mb-4 relative z-10"></i>
      <div class="text-3xl font-extrabold text-text-primary mb-1 relative z-10 group-hover:icon-gradient transition-all duration-300">
        {{ 'projects.stats.developers.count' | translate }}
      </div>
      <div class="label uppercase tracking-widest text-text-muted mt-2 relative z-10">
        {{ 'projects.stats.developers.label' | translate }}
      </div>
    </div>

    <!-- Units -->
    <div
      class="surface-card relative overflow-hidden group p-8 text-center flex flex-col items-center justify-center"
    >
      <div class="absolute inset-0 bg-gradient-to-b from-primary-soft/20 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100"></div>
      <i class="fa-solid fa-house text-3xl icon-gradient mb-4 relative z-10"></i>
      <div class="text-3xl font-extrabold text-text-primary mb-1 relative z-10 group-hover:icon-gradient transition-all duration-300">
        {{ 'projects.stats.units.count' | translate }}
      </div>
      <div class="label uppercase tracking-widest text-text-muted mt-2 relative z-10">
        {{ 'projects.stats.units.label' | translate }}
      </div>
    </div>

    <!-- Locations -->
    <div
      class="surface-card relative overflow-hidden group p-8 text-center flex flex-col items-center justify-center"
    >
      <div class="absolute inset-0 bg-gradient-to-b from-primary-soft/20 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100"></div>
      <i class="fa-solid fa-location-dot text-3xl icon-gradient mb-4 relative z-10"></i>
      <div class="text-3xl font-extrabold text-text-primary mb-1 relative z-10 group-hover:icon-gradient transition-all duration-300">
        {{ 'projects.stats.locations.count' | translate }}
      </div>
      <div class="label uppercase tracking-widest text-text-muted mt-2 relative z-10">
        {{ 'projects.stats.locations.label' | translate }}
      </div>
    </div>
  </div>
</div>
